// vendor
import { defineComponent, ref, reactive, watch } from "@vue/composition-api";
// project
import { matchEmail } from "@/utils/text";


type FormData  = {
	email:string,
	password:string
};

export const LoginForm = defineComponent({
	
	setup(props, context){

		const error = ref<string|null>(null);
		const formData = reactive<FormData>({ email:"", password:"" });

		watch(formData, () => error.value = null);

		const submit = async () => {
			if(formData.email.length === 0){ error.value = "Email is required"; }
			else if(!matchEmail(formData.email)){ error.value = "Invalid email"; }
			else if(formData.password.length === 0){ error.value = "Password is required"; }
			if(error.value){ return; }
			try{
				await context.root.$store.dispatch("login", formData);
				context.root.$router.push("/");
			}catch(err){
				error.value = "Invalid credentials";
			}
		}

		if(context.root.$store.getters.authenticated){
			context.root.$router.push("/");
		}

		return {
			error,
			formData,
			submit
		};
	}
});